export default function TrustSection() {
  const benefits = [
    {
      icon: 'ri-flashlight-line',
      title: 'Faster Research',
      description: 'Find organized product information without wasting hours searching through endless pages and tabs.',
    },
    {
      icon: 'ri-stack-line',
      title: 'Better Organization',
      description: 'Browse products through structured categories designed for intuitive navigation and discovery.',
    },
    {
      icon: 'ri-scales-3-line',
      title: 'Smart Comparison',
      description: 'Compare products, prices, and important details side by side for informed decision making.',
    },
    {
      icon: 'ri-user-smile-line',
      title: 'Beginner Friendly',
      description: 'Easy workflow designed for new users — no technical knowledge or prior experience required.',
    },
    {
      icon: 'ri-image-line',
      title: 'QC Photo Guides',
      description: 'Learn how to review product quality check photos and understand important visual details.',
    },
  ];

  return (
    <section className="bg-foreground-950 py-16 md:py-24 px-4 md:px-10">
      <div className="max-w-5xl mx-auto text-center">
        {/* Header */}
        <span className="inline-block px-4 py-1.5 bg-foreground-800 text-foreground-200 rounded-full text-xs font-semibold uppercase tracking-wide mb-5">
          Independent Educational Platform
        </span>
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight max-w-3xl mx-auto">
          Curated Research. <span className="italic text-accent-500">Organized Finds.</span> Confident Shopping.
        </h2>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 bg-background-50 text-foreground-950 rounded-full text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-background-100 transition-colors"
          >
            Superbuy Sheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 bg-transparent border border-foreground-500/40 text-background-50 rounded-full text-sm font-semibold whitespace-nowrap cursor-pointer hover:border-foreground-200 transition-colors"
          >
            Buy It Now
          </a>
        </div>

        {/* Benefit Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mt-16">
          {benefits.map((item) => (
            <div
              key={item.title}
              className="bg-foreground-900 rounded-2xl p-5 text-left hover:bg-foreground-800 transition-colors cursor-default"
            >
              <div className="w-9 h-9 rounded-lg bg-accent-500/15 flex items-center justify-center mb-4">
                <i className={`${item.icon} text-accent-500 text-base`}></i>
              </div>
              <h3 className="text-sm font-semibold text-background-50 mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-300 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}